import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, DEFAULTNFTIMAGE } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";





const NftCreationOption = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showTraitPopup, setShowTraitPopup] = useState(false);
    const [traitList, setTraitList] = useState([]);
    const [nftCollections, setNftCollections] = useState([]);
    const [nftImage, setNftImage] = useState(DEFAULTNFTIMAGE);
    const [nftImageForPayload, setNftImageForPayload] = useState(null);









    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {

        }
    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">

                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <img src={require('../assets/img/png/nft-type.jpg')} alt="Image" style={{ width: '100%', height: '100%' }} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2>Create</h2>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-md-12">
                                    {getAllSessionData().loginPlatform != 'paybito' ? <div className="create-nft-type">
                                    <Link to="/import-collection">
                                            <h3><i className="fa fa-diamond" aria-hidden="true"></i> Drop a collection </h3>
                                            <span>Launch your NFT collection for others to mint.</span>
                                        </Link>
                                    </div> : <div className="create-nft-type">
                                    <Link to="/create-collection">
                                            <h3><i className="fa fa-diamond" aria-hidden="true"></i> Create a collection </h3>
                                            <span>Launch your NFT collection for others to mint.</span>
                                        </Link>
                                    </div>}
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="create-nft-type">
                                        <Link to="/mint-nft">
                                            <h3> <i className="fa fa-picture-o" aria-hidden="true"></i> Mint an NFT</h3>
                                            <span>Mint an NFT directly to your wallet.</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>










            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default NftCreationOption;